import { useContext } from 'react';
import { useDataModel } from '@thd-nucleus/data-sources';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { ProductResultsContext } from '../components/ProductResultsContext';

const useSearchModelData = () => {
  // Get context data AND loading state
  const productResultsContext = useContext(ProductResultsContext);
  const {
    data: contextData,
    loading: contextLoading,
    responseLoading: contextResponseLoading,
    error: contextError,
    pageContext,
    queryVariables
  } = productResultsContext || {};

  const isContextLoading = contextLoading || contextResponseLoading;

  const ctx = useContext(ExperienceContext);
  const { customContext } = ctx || {};
  const variables = customContext?.variables || {};

  const defaultOptions = {
    variables,
    ssr: true,
    // Skip if context has data OR if context is actively loading
    skip: (!variables.navParam && !variables.keyword) || contextData || isContextLoading,
  };

  const {
    data: searchModelData,
    loading, error, responseLoading,
    variables: dataModelVariables
  } = useDataModel('searchModel', defaultOptions);

  // This will match the shape of the ProductResultsContext
  return {
    data: contextData || searchModelData,
    loading: isContextLoading || loading,
    error: contextError || error,
    pageContext: pageContext || customContext?.pageType,
    queryVariables: queryVariables || dataModelVariables,
    responseLoading: contextResponseLoading || responseLoading
  };
};

export { useSearchModelData };